<template>
  <div :class="{'d-none': (!showLatestNews || !latestNews)}">
    <!-- Desktop -->
    <div v-if="isDesktop" class="latest-news-desktop">
      <div v-if="latestNews">
        <div class="flex-grow-1 text-left ">
          <template v-if="latestNews.previewImg">
            <img
              :src="latestNews.previewImg"
              class="news-cover-img position-absolute absolute-center"
            />
            <div class="gradient-bg"></div>
          </template>
          <div
            class="two-lines"
            :class="{ 'text-white': latestNews.previewImg }"
            :style="{ 'marginTop': latestNews.previewImg ? '90px': '0' }"
            >{{ latestNews.newsTitle }}
          </div>
          <div class="cursor" :class="{ 'text-white': latestNews.previewImg }" style="margin-top: 12px;" @click="goToNews(latestNews.newsId)">
            <span class="font-weight-bold text-sm text-decoration-underline">{{ $t('message.news.read_more') }}</span>
            <img height="12" :src="icon.continue_icon_white" />
          </div>
        </div>
        <div class="btn-close ml-2" @click="closeNews">
          <img :src="latestNews.previewImg ? icon.close_icon_black : icon.close_icon" />
        </div>
      </div>
    </div>
    <!-- Mobile -->
    <div v-else class="latest-news-mobile">
      <div v-if="latestNews" class="d-flex align-items-center">
        <img
          :src="icon.news_icon"
          style="width:18px; margin: 0 14px 0 4px;"
        >
        <div class="flex-grow-1 text-left">
          <div class="one-line">{{ latestNews.newsTitle }}</div>
          <div class="cursor" @click="goToNews(latestNews.newsId)">
            <span class="font-weight-bold text-sm text-decoration-underline mr-1">{{ $t('message.news.read_more') }}</span>
            <img height="10" :src="icon.continue_icon_white" />
          </div>
        </div>
        <div class="btn-close flex-shrink-0 ml-2" @click="closeNews">
          <img :src="icon.close_icon" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LatestNews',
  props: {
    isDesktop: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      icon: {
        news_icon: require('@/assets/icon/ic_news.svg'),
        close_icon: require('@/assets/icon/ic_close_btn.png'),
        close_icon_black: require('@/assets/icon/ic_close_btn_black.png'),
        continue_icon_white: require('@/assets/icon/ic_continue_white.svg')
      },
      showLatestNews: true,
      latestNews: null
    };
  },
  mounted () {
    this.getLatestNews()
  },
  methods: {
    closeNews() {
      this.showLatestNews = false
      if (this.latestNews?.newsId) {
        localStorage.setItem('latestReadNewsId', this.latestNews.newsId)
      }
    },
    goToNews(newsId) {
      this.closeNews()
      sessionStorage.setItem('newsId', newsId)
      this.$router.push({ name: 'News' })
    },
    // ajax
    getLatestNews() {
      const offset = 0
      const limit = 1
      let scope = this

      // WS-118
      var url =
        process.env.API_URL +
        `/front/news/list?offset=${offset}&limit=${limit}`

      scope.latestNews = null
      this.axios
        .get(url)
        .then(response => {
          if (response.status === 200 && response.data.code === 200) {
            const ar = response.data.data
            if (ar instanceof Array && ar.length) {
              const latestNews = ar[0]
              if (localStorage.latestReadNewsId != latestNews.newsId) scope.latestNews = latestNews
            }
          }
        })
        .catch(function(error) {
          console.log(error)
        })
    },
  }
}
</script>

<style lang="scss" scoped>
.latest-news-mobile,
.latest-news-desktop {
  color: white;
  background: rgba(0, 0, 0, 0.72);
  border-radius: 8px;
  z-index: 1;
  line-height: 1.375rem;
  position: absolute;
}
.btn-close {
  cursor: pointer;
  img {
    height: 20px;
  }
}
.latest-news-mobile{
  width: calc(100dvw - 24px);
  padding: 8px 12px;
  position: relative;
  right: 0;
  margin-top: 10px;
}
.latest-news-desktop {
  width: 287px;
  padding: 14px 30px 14px 11px;
  top: 118px;
  right: 12px;
  .btn-close {
    position: absolute;
    top: 9px;
    right: 8px;
  }
  .news-cover-img {
    z-index: -1;
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 10px;
  }
  .gradient-bg {
    width: 100%;
    height: 100%;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 35.42%, #000000 100%), #FFF0;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 10px;
    z-index: -1;
  }
}
</style>
